import { permissionsSelector } from '@air/redux-permissions';

import { useAirSelector } from '~/utils/ReduxUtils';

export type UseFormPermissionsParams = {
  formId: string | undefined;
};

export const useFormPermissions = ({ formId }: UseFormPermissionsParams) => {
  const formPermissions = useAirSelector((st) => permissionsSelector(st, 'formIds', formId));

  return {
    formPermissions,
  };
};
